//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.11.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngOption', srsngOption);

    function srsngOption($compile, $timeout, $parse) {

        return {
            require: '^^srsngSelect',
            restrict: 'E',
            scope: {
                ngModel: '='
            },
            transclude: true,
            templateUrl: 'container/ui/app/widgets/select/option/option.html',
            controller: controller,
            link: link
        };

        function controller($scope) {
            // this is intentional override
        }

        function link(scope, element, attrs, selectCtrl, $transclude) {

            scope.getElement = () => {
                return element;
            };

            scope.selectOption = () => {
                selectCtrl.setSelectValue(scope.ngModel);
            };

            scope.getContent = callback => {
                $transclude(clone => callback(clone));
            };

            selectCtrl.addOption(scope);
        }
    }
})();